import { Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import ConvergeAppBar from './app-bar';
import './app-layout.scss';
import { useState } from 'react';
import ConvergeAppDrawer from './app-drawer';

export default function AppLayout() {
  const location = useLocation();
  const isNewPage = location.pathname.includes('claim');
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  return (
    <>
      <ConvergeAppBar />
      <ConvergeAppDrawer
        isDrawerOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
      <Box
        className={
          isNewPage
            ? 'new-application-body-wrapper'
            : 'application-body-wrapper'
        }
        sx={{
          backgroundColor: 'background.default',
          flex: 1,
        }}
      >
        <Outlet />
      </Box>
    </>
  );
}
